

import React, { Component } from 'react';
import { Toast } from 'devextreme-react/toast';

class Toastr extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            type: "error",
            message: "Message"
        };
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.setType = this.setType.bind(this);
        this.setMessage = this.setMessage.bind(this);
    }

    setType(type) {
        this.setState({
            type: type
        });
    };
    setMessage(message) {
        this.setState({
            message: message
        });
    };
    show() {
        this.setState({
            isVisible: true
        });
    };

    hide() {
        this.setState({
            isVisible: false
        });
    };

    render() {
        return (
            <div>
                <Toast
                    visible={this.state.isVisible}
                    message={this.state.message}
                    type={this.state.type}
                    onHiding={this.hide}
                    height={55}
                    width={300}
                    position={{ at: 'top center', my: 'top center', offset: '0 20' }}
                />
            </div>
        );
    };
}


export default Toastr;
